import axios from "axios";
import { useEffect, useState } from "react";
import {Modal} from "react-bootstrap";
import Select from "react-select";
import {useSelector} from 'react-redux';

const AddNewUser = ({show, setShow, formData, action, setFormData, setNotification, setReRender}) => {
    const [accounts, setAccounts] = useState({copart: [], iaai: []});
    const [loader, setLoader] = useState(false);
    const user = useSelector((state) => state.user);
    const [admins, setAdmins] = useState([]);

    const handlers = {
        createNewUser(e){
            e.preventDefault();
            if(formData.role == ""){
                setNotification({show: true, type: "error", text: "Select role to continue"});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            }else if(formData.password != formData.repeat_password){
                setNotification({show: true, type: "error", text: "Passwords don't match"});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            }else{
                setLoader(true);
                const copartAccount = formData.copart_accounts.map((ca) => ca.value);
                const iaaiAccount = formData.iaai_accounts.map((ia) => ia.value);
                axios.post('/api/extension/v1/users', {...formData, copart_accounts: copartAccount, iaai_accounts: iaaiAccount})
                    .then((res) => {
                        setNotification({show: true, type: "success", text: res.data.message.en});
                        setTimeout(() => {
                            setNotification({show: false, title: "", text: ""});
                        }, 3000);
                        setLoader(false);
                        setShow((prev) => ({...prev, createUser: false}))
                        setReRender((prev) => prev + 1)
                    })
                    .catch((err) => {
                        setNotification({show: true, type: "error", text: err.response.data.message.en});
                        setTimeout(() => {
                            setNotification({show: false, title: "", text: ""});
                        }, 3000);
                        setLoader(false);
                    })
            }
        },
        editUser(e){
            e.preventDefault();
            if(formData.role == ""){
                setNotification({show: true, type: "error", text: "Select role to continue"});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            }else{
                setLoader(true);
                const copartAccount = formData.copart_accounts.map((ca) => ca.value);
                const iaaiAccount = formData.iaai_accounts.map((ia) => ia.value);
                axios.put(`/api/extension/v1/users/${formData.id}`, {...formData, copart_accounts: copartAccount, iaai_accounts: iaaiAccount})
                    .then((res) => {
                        setNotification({show: true, type: "success", text: res.data.message.en});
                        setTimeout(() => {
                            setNotification({show: false, title: "", text: ""});
                        }, 3000);
                        setLoader(false);
                        setShow((prev) => ({...prev, createUser: false}))
                        setReRender((prev) => prev + 1)
                    })
                    .catch((err) => {
                        setNotification({show: true, type: "error", text: err.response.data.message.en});
                        setTimeout(() => {
                            setNotification({show: false, title: "", text: ""});
                        }, 3000);
                        setLoader(false);
                    })
            }
        }
    }

    useEffect(() => {
        axios('/api/extension/v1/accounts?page=1&limit=200&keyword=&sort_by=id&sort_order=DESC&auction=copart')
            .then((res) => {
                const data = res.data.data.map((account) => ({label: account.buyer, value: account.buyer}));
                setAccounts((prev) => ({...prev, copart: [...data]}))
            })
            .catch((err) => {
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            })

        axios('/api/extension/v1/accounts?page=1&limit=200&keyword=&sort_by=id&sort_order=DESC&auction=iaai')
            .then((res) => {
                const data = res.data.data.map((account) => ({label: account.buyer, value: account.buyer}));
                setAccounts((prev) => ({...prev, iaai: [...data]}))
            })
            .catch((err) => {
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            })
        
        axios('/api/extension/v1/admins')
            .then((res) => {
                const data = res.data.data;
                setAdmins([...data]);
            })
            .catch((err) => {
                // setNotification({show: true, type: "error", text: err.response.data.message.en});
                // setTimeout(() => {
                //     setNotification({show: false, title: "", text: ""});
                // }, 3000);
            })
    }, [])

    return(
        <Modal show={show} onHide={() => setShow((prev) => ({...prev, createUser: false}))} size="xl" centered>
            <Modal.Header closeButton><h2 className="modal-title-text">{action == "add" ? "Add New User" : "Edit User"}</h2></Modal.Header>
            <Modal.Body>
                <div className="container">
                    <form style={{width: "100%"}} className="row" onSubmit={action == "add" ? handlers.createNewUser : handlers.editUser}>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-name">Name*</label>
                                <input id="form-name" required placeholder="Enter dealer name" type="text" className="form-control" name="name" value={formData.name} onChange={(e) => setFormData((prev) => ({...prev, name: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-surname">Surname*</label>
                                <input id="form-surname" required placeholder="Enter dealer surname" type="text" className="form-control" name="surname" value={formData.surname} onChange={(e) => setFormData((prev) => ({...prev, surname: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-email">Email*</label>
                                <input id="form-email" required placeholder="Enter email address" type="email" className="form-control" name="email" value={formData.email} onChange={(e) => setFormData((prev) => ({...prev, email: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-phone">Phone*</label>
                                <input id="form-phone" required placeholder="Enter phone number" type="text" className="form-control" name="phone" value={formData.phone} onChange={(e) => setFormData((prev) => ({...prev, phone: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-phone">Copart Accounts*</label>
                                <Select
                                    isMulti
                                    className={"no-padding"}
                                    options={accounts.copart}
                                    value={formData.copart_accounts}
                                    onChange={(e) => {
                                        setFormData((prev) => ({ ...prev, copart_accounts: [...e] }))
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-phone">IAAI Accounts*</label>
                                <Select
                                    isMulti
                                    className={"no-padding"}
                                    options={accounts.iaai}
                                    value={formData.iaai_accounts}
                                    onChange={(e) => {
                                        setFormData((prev) => ({ ...prev, iaai_accounts: [...e] }))
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-amount-limit">Bid Amount Limit*</label>
                                <input id="form-amount-limit" min={0} required placeholder="Enter amount limit" type="number" className="form-control" name="amount-limit" value={formData.limited_amount} onChange={(e) => setFormData((prev) => ({...prev, limited_amount: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-purchase-limit">Purchase Limit*</label>
                                <input id="form-purchase-limit" min={0} required placeholder="Enter purchase limit" type="number" className="form-control" name="purchase-limit" value={formData.purchase_limit} onChange={(e) => setFormData((prev) => ({...prev, purchase_limit: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-role">Role*</label>
                                <select id="form-role" min={0} required className="form-control" name="role" value={formData.role} onChange={(e) => setFormData((prev) => ({...prev, role: e.target.value}))}>
                                    <option value={""}>Select Role</option>
                                    <option value={"admin"}>Admin</option>
                                    <option value={"moderator"}>Sub Admin</option>
                                    <option value={"user"}>User</option>
                                </select>
                            </div>
                        </div>
                        {user.role == "admin" && <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-admin">Admin*</label>
                                <select required id="form-admin" className="form-control" name="admin" value={formData.admin} onChange={(e) => setFormData((prev) => ({...prev, admin: e.target.value}))}>
                                    <option value={""}>Select Admin</option>
                                    {
                                        admins.map((admin, id) => <option key={id} value={admin.id}>{admin.username}</option>)
                                    }
                                </select>
                            </div>
                        </div>}
                        <div className="col-md-12">
                            <h4 style={{color: "#afb9cf"}}>Authorization Info</h4>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-username">Username*</label>
                                <input id="form-username" required placeholder="Enter username" type="text" className="form-control" name="username" value={formData.username} onChange={(e) => setFormData((prev) => ({...prev, username: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-password">Password{action == "add" && "*"}</label>
                                <input disabled={action == "edit"} id="form-password" required={action == "add"} placeholder="Enter password" type="password" className="form-control" name="password" value={formData.password} onChange={(e) => setFormData((prev) => ({...prev, password: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-repeat-password">Repeat Password{action == "add" && "*"}</label>
                                <input disabled={action == "edit"} id="form-repeat-password" required={action == "add"} placeholder="Repeat Password" type="password" className="form-control" name="password" value={formData.repeat_password} onChange={(e) => setFormData((prev) => ({...prev, repeat_password: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <h4 style={{color: "#afb9cf"}}>Activity Statuses</h4>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group checkbox-container">
                                <input id="form-copart-status" type="checkbox" name="copart_status" defaultChecked={formData.copart_status} value={formData.copart_status} onChange={(e) => setFormData((prev) => ({...prev, copart_status: e.target.checked}))}/>
                                <label htmlFor="form-copart-status">Copart Status</label>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group checkbox-container">
                                <input id="form-iaai-status" type="checkbox" name="iaai_status" defaultChecked={formData.iaai_status} value={formData.iaai_status} onChange={(e) => setFormData((prev) => ({...prev, iaai_status: e.target.checked}))}/>
                                <label htmlFor="form-iaai-status">IAAI Status</label>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="form-group checkbox-container">
                                <input id="form-is-active" type="checkbox" name="is_active" defaultChecked={formData.is_active} value={formData.is_active} onChange={(e) => setFormData((prev) => ({...prev, is_active: e.target.checked}))}/>
                                <label htmlFor="form-is-active">Is Active</label>
                            </div>
                        </div>
                        <div className="modal-action-buttons">
                            <button type="submit" disabled={loader} className="submit-modal-form-btn">{loader ? <div className="button-loader"></div> : (action == "add" ? "Submit" : "Save")}</button>
                            <button type="button" onClick={() => setShow(false)} className="cancel-modal-form-btn">Cancel</button>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddNewUser